import React from "react";
import {BrowserRouter as Router, Routes, Route,} from "react-router-dom";
import Main from "./app/main";
import Invoices from "./app/invoices";
import TripPayment from "./app/trippayment";
import PageNotFound from "./app/pagenotfound";
import { Provider } from "react-redux";
import store from "./redux/store";
import FeedbackPage from "./app/feedback";
import ThankYouPage from "./app/thankyou";

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path="/links/trip-summary/:tripId" element={<Main />} />
          <Route path="/trip-summary/:tripId" element={<Main />} />
          <Route path="/links/invoice-summary/:invoiceId" element={<Invoices />} />
          <Route path="/invoice-summary/:invoiceId" element={<Invoices />} />
          <Route path="/links/trip-checkout/:tripId" element={<TripPayment />} />
          <Route path="/trip-checkout/:tripId" element={<TripPayment />} />
          <Route path="/links/feedback" element={<FeedbackPage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/links/thankyou" element={<ThankYouPage />} />
          <Route path="/thankyou" element={<ThankYouPage />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
